import { createContext } from "react";

/**
 * The org's display settings, once, for the whole tree.
 *
 * `backOrderUsesOwnColour` is Gloria's open question (see `shared/status.ts`)
 * and it is an *org* setting — one row, one answer, every screen. It was being
 * prop-drilled: each screen ran its own `useQuery(api.users.settings)` and
 * threaded the flag down to every `StatusPill`, which meant a screen that
 * forgot the prop rendered back-order in the other colour and nothing failed.
 * Two colours for one status, live, is exactly the confusion the status
 * language exists to prevent.
 *
 * The shell already queries this to decide whether to show the demo banner, so
 * it provides the value and `StatusPill` reads it when no prop is passed. An
 * explicit prop still wins — the back-order report deliberately passes the
 * flag off its own payload, so the report and its query cannot disagree.
 *
 * The default matches `presentLineStatus`'s own default: red, the shipped
 * answer, for anything rendered outside the provider.
 */
export interface OrgSettings {
  backOrderUsesOwnColour: boolean;
}

export const OrgSettingsContext = createContext<OrgSettings>({
  backOrderUsesOwnColour: false,
});
